import {
  addDaysToDate,
  getInitialValues,
  requiredMessage,
  today,
  onlyNumbersInput,
} from "@/lib/utils";
import AuthService from "@/services/api/auth/auth";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import toast from "@/lib/toast";
import MapView from "@/components/Map/MapView";
import { useDrawer } from "@/components/Drawer/context/DrawerContext";
import Modal from "@/components/Modal/Modal";
import { Typography } from "@mui/material";
import Pagination from "@/components/Table/Pagination";
import formRenderer from "@/lib/formRenderer";
import Table from "@/components/Table/Table";
import { useDistributor } from "../context/DistributorIDcontext";
import { Tabs, Tab, Box } from "@mui/material";
import CustomHeader from "@/components/CustomHeader/CustomHeader";
import { useSearchPagination } from "@/hooks/useSearchPagination";
import { createOrderColumns } from "./component/OrderColumn";
import styles from "./Order.module.scss"
import ApprovedSalesDeliveryModal from "./component/ApprovedSalesDeliveryModal"
import StockService from "@/services/api/stocks/stocks";
interface RetilerRow {
  RetailerShopName: string;
  PersonName: string;
  Designation: string;
  Email: string;
  PhoneNumber: string;
  Action: string;
}

const ORDER_TABS = [
  { key: "AllOrders", label: "All Orders" },
  { key: "Requested", label: "Requested" },
  { key: "Approved", label: "Approved" },
  { key: "PartialDelivered", label: "Partial Delivered" },
  { key: "Delivered", label: "Delivered" },
  { key: "Declined", label: "Declined" },
];

const Order: React.FC = () => {
  const { setDistributorId } = useDistributor();
  const { openDrawer, closeDrawer } = useDrawer();
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [Localities, setLocalities] = useState<any[]>([]);
  const [attendanceData, setAttendanceData] = useState<RetilerRow[]>([]);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [mapLocation, setMapLocation] = useState({
    lat: 18.96905,
    lng: 72.82118,
  });
  const [modalOpen, setModalOpen] = useState(false);

  const handleCloseModal = () => setModalOpen(false);
  const [countries, setCountries] = useState<any[]>([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [shareLink, setShareLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState("AllOrders");
  const [RejectModal, setRejectModal] = useState(false);
  const [retailerOption, setretailerOption] = useState([]);
  const [rejectReason, setRejectReason] = useState("");
  const [productCodeOption, setproductCodeOption] = useState([]);
  const [orderDateValue, setOrderDateValue] = useState<string>("");
  //Approved tab action button state
 const [deliverModalOpen, setDeliverModalOpen] = useState(false);
  const [selectedOrderForDelivery, setSelectedOrderForDelivery] = useState<any>(null);

  const handleOpenDeliverModal = (row: any) => {
    setSelectedOrderForDelivery(row);
    setDeliverModalOpen(true);
  };

  
  const handleCloseDeliverModal = () => {
    setDeliverModalOpen(false);
    setSelectedOrderForDelivery(null);
  };

  
  const handleDeliverySuccess = () => {
    FetchAllOrders(); 
    setDeliverModalOpen(false);
    setSelectedOrderForDelivery(null);
  };

  const StatusCheck = async (
    action: "ACCEPT" | "REJECT",
    row: any,
    rejectionReason?: string
  ) => {
    if (action === "REJECT" && !rejectionReason) {
      setSelectedRow(row);
      setRejectModal(true);
      return;
    }

    const payload = {
      orderId: row.id,
      rejectionReason: action === "REJECT" ? rejectionReason : "",
      isApproved: action === "ACCEPT" ? true : false,
    };

    try {
      const res = await AuthService.OrderStatus(payload);

      if (res?.message === "Success") {
        toast.success(
          action === "ACCEPT" ? "Retailer Approved" : "Retailer Rejected"
        );
        FetchAllOrders();
      } else {
        toast.error(res?.message || "Operation failed");
      }
    } catch (err: any) {
      const errorMessage =
        err?.error || err?.message || "Something went wrong!";
      toast.error(errorMessage);
    }
  };

  const FetchAllOrders = async () => {
    const config = TAB_CONFIG[activeTab];
    if (!config) return;

    try {

      const data = {
        from,
        to,
        search: debouncedSearch || "",
        status: config.status,
      };

      const res = await AuthService.GetOrders(data);
      setTotalRecords(res?.data?.totalRecords);

      const item = res?.data?.items.map((item: any) => ({
        id: item.id,
        orderNumber: item.orderNumber,
        orderDate: item.orderDate,
        retailerName: item.retailerName,
        companyName: item.companyName,
        totalQuantity: item.totalQuantity,
        expectedDeliveryDate: item.expectedDeliveryDate,
        retailerEmail: item.email,
        retailer: item.retailerName,
        comments: item.comments,
        shippingAddress: item.shippingAddress,
        orderDetails: item.orderDetails,
        status: item.status,
      }));

      setAttendanceData(item);
      setTotalRecords(res?.data?.totalRecords || 0);
    } catch {
    } finally {
      setLoading(false);
    }
  };
  
  const columns = useMemo(
    () => createOrderColumns(openDrawer, StatusCheck,FetchAllOrders),
    [openDrawer,FetchAllOrders]
  );

  const TAB_CONFIG: any = {
    AllOrders: {
      status: "",
      columns: columns.AllOrders,
    },

    Requested: {
      status: "Pending",
      columns: columns.requestedColumns,
    },
    Approved: {
      status: "Approved",
      columns: columns.approvedColumns,
    },
    PartialDelivered  : {
      status: "PartialDelivered",
      columns: columns.partaildeliveredColumns,
    },
    Delivered: {
      status: "Delivered",
      columns: columns.deliveredColumns,
    },
    Declined: {
      status: "Rejected",
      columns: columns.declinedColumns,
    },
  };

  const handleOpenModal = async () => {
    const response = await AuthService.GetRetailerOption();
    // const prodresp = await StockService.getStock({
    //   from,
    //   to,
    //   search: debouncedSearch || undefined,
    //   fromDate: null,
    //   toDate: null,
    //   warehouseId: 0,
    //   inventoryId: 0,
    //   distributorId: 0,
    // });
    const productlist = await AuthService.GetProductOption()
    const options = response?.data?.map((item: any) => ({
      label: item.name,
      value: item.id,
    }));

    const prodoptions = productlist?.data?.map((item : any) => ({
      label : item.productName,
      value : item.productId
    }))
    
    // const prodoptions =
    //   prodresp?.data?.items?.flatMap((warehouse: any) =>
    //     warehouse.inventory.map((item: any) => ({
    //       label: item.productName,
    //       value: item.productId,
    //     }))
    //   ) || [];
    setproductCodeOption(prodoptions);
    setretailerOption(options);

    reset({
      ...getInitialValues(formConfig),
      Product: [{ productCode: "", quantity: "" }],
    });
    setSelectedRow(null);
    setModalOpen(true);
  };

  const formConfig = useMemo(
    (): Record<string, any> => ({
      RetailerName: {
        defaultValue: "",
        validations: { required: requiredMessage("Retailer Name") },
        controlType: "select",
        placeholder: "Enter Retailer Name",
        label: "Retailer Name",
        isRequired: true,
        options: retailerOption,
        isControlled: true,
      },
      orderDate: {
        defaultValue: "",
        validations: { required: requiredMessage("Order Date") },
        controlType: "date",
        placeholder: "Enter orderDate",
        label: "Order Date",
        isRequired: true,
        props: {
          min: today,
        },
      },
      expectedDeliveryDate: {
        defaultValue: "",
        validations: { required: requiredMessage("Expected Delivery Date") },
        controlType: "date",
        placeholder: "Enter expected Delivery Date",
        label: "Expected Delivery Date",
        isRequired: true,
        isDisabled: !orderDateValue,
        props: {
          min: orderDateValue ? addDaysToDate(orderDateValue,0) : undefined,
        },
      },
    }),
    [retailerOption, orderDateValue]
  );

  const getProductRowConfig = (index: number) => {

    const currentSelected = watchedProducts[index]?.productCode;

    const filteredOptions = productCodeOption?.filter(
      (option: any) =>
        !selectedProductCodes.includes(option.value) ||
        option.value === currentSelected
    );

    return {
      [`Product.${index}.productCode`]: {
        controlType: "select",
        label: "Product Code",
        placeholder: "Select Product Code",
        validations: { required: "Product code is required" },
        options: filteredOptions,
        showLabel: true,
        isRequired: true,
        isControlled: true,
      },
      [`Product.${index}.quantity`]: {
        controlType: "input",
        label: "Qty",
        placeholder: "Enter Quantity",
        validations: { required: "Quantity is required" },
        props: {
          type: "number",
          onKeyDown: onlyNumbersInput,
        },
        showLabel: true,
        isRequired: true,
      },
    };
  };


  const { register, handleSubmit, control, watch, formState, setValue, reset } =
    useForm({
      defaultValues: {
        ...getInitialValues(formConfig),
        Product: [{ productCode: "", quantity: "" }],
      },
      mode: "onTouched",
    });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "Product",
  });

  const watchedProducts = watch("Product") || [];
  const selectedProductCodes = watchedProducts
  .map((p: any) => p?.productCode)
  .filter(Boolean);

  const selectedType = watch("type");
  const selectedCountryId = watch("countryId");
  const selectedStateId = watch("stateId");
  const selectedCityId = watch("cityId");
  const watchedOrderDate = watch("orderDate");

  // Sync orderDateValue state with watched form value
  useEffect(() => {
    setOrderDateValue(watchedOrderDate || "");
  }, [watchedOrderDate]);

  const {
    debouncedSearch,
    search,
    setSearch,
    pageSelected,
    setPageSelected,
    rowsPerPageValue,
    setRowsPerPageValue,
  } = useSearchPagination();

  const from = (pageSelected - 1) * rowsPerPageValue + 1;
  const to = pageSelected * rowsPerPageValue;

  

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const countriesData = await AuthService.getCountries();
        const newCountries = countriesData.map((obj) => ({
          value: obj.countryId,
          label: `${obj.countryCode} ${obj.name}`,
        }));
        setCountries(newCountries);
      } catch (err: any) {
        toast.error("Failed to load countries, please try again.");
      }
    };

    loadCountries();
  }, []);

  useEffect(() => {
    if (!selectedCountryId) return;
    const loadStates = async () => {
      try {
        const stateData = await AuthService.GetState(selectedCountryId);
        const newStates = stateData.map((s: any) => ({
          value: s.stateId,
          label: s.name,
        }));
        if (!editModalOpen) {
          setValue("stateId", null);
          setValue("cityId", null);
        }
        setStates(newStates); // update state options
        setCities([]);
        // control.setValue("State", null);
        // control.setValue("City", null);
      } catch (err: any) {
        toast.error("Failed to load states");
      }
    };
    loadStates();
  }, [selectedCountryId, setValue]);

  useEffect(() => {
    if (!selectedStateId) return;

    const loadCities = async () => {
      try {
        const cityData = await AuthService.GetCity(selectedStateId);
        const newCities = cityData.map((c: any) => ({
          value: c.cityId,
          label: c.name,
        }));
        setCities(newCities);
      } catch (err: any) {
        toast.error("Failed to load cities");
      }
    };
    loadCities();
  }, [selectedStateId]);

  useEffect(() => {
    if (!selectedCityId) return;

    const loadLocality = async () => {
      try {
        const LocalityData = await AuthService.GetLocality(selectedCityId);
        const newLocalities = LocalityData.map((c: any) => ({
          value: c.CityId,
          label: c.Name,
        }));
        setLocalities(newLocalities);
      } catch (err) {
        toast.error("something went wrong");
      }
    };
    loadLocality();
  }, [selectedCityId, setValue]);

  useEffect(() => {
    if (!editModalOpen || !selectedRow || countries.length === 0) return;

    setValue("countryId", selectedRow.countryId, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [editModalOpen, selectedRow, countries, setValue]);

  useEffect(() => {
    if (!editModalOpen || !selectedRow || states.length === 0) return;

    setValue("stateId", selectedRow.stateId, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [editModalOpen, selectedRow, states, setValue]);
  // When edit modal opens
  useEffect(() => {
    if (!editModalOpen || !selectedRow || cities.length === 0) return;

    setValue("cityId", selectedRow.cityId, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [editModalOpen, selectedRow, cities, setValue]);

  useEffect(() => {
    FetchAllOrders();
  }, [pageSelected, debouncedSearch, activeTab]);

  const onSubmit = async (values: any) => {
    const payload = {
      retailerId: Number(values?.RetailerName),
      orderDate: values.orderDate,
      expectedDeliveryDate: values.expectedDeliveryDate,
      products:
        values.Product?.map((p: any) => ({
          productId: p.productCode ?? 0,
          quantity: Number(p.quantity) ?? 0,
        })) || [],
    };

    try {
      const res = await AuthService.AddOrders(payload);
      if (res?.status === 200) {
        toast.success(res?.message || "Retailer added successfully");
        setModalOpen(false);
        FetchAllOrders();
      } else {
        // API returned failure response
        toast.error(res?.error || "Something went wrong");
      }
    } catch (error: any) {
      const backendMessage =
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";
      toast.error(backendMessage);
    } finally {
    }
  };

  const handleSave = (selectedAddress: any) => {
    setMapModalOpen(false);
  };

  const handleSelectLocation = (lat: number, lng: number, addr: string) => {
    setMapLocation({ lat, lng });
    setSelectedAddress(addr);
    setValue("address", addr);
    setValue("latitude", lat);
    setValue("longitude", lng);
  };
  const dynamicFormConfig = (() => {
    const config: any = { ...formConfig };

    if (selectedType === "Retailer") {
      const entries = Object.entries(config);

      const typeIndex = entries.findIndex(([key]) => key === "type");

      const distributorField: [string, any] = [
        "DistributorCode",
        {
          defaultValue: "",
          validations: { required: requiredMessage("Distributor Code") },
          controlType: "input",
          label: "Distributor Code",
          isRequired: true,
        },
      ];

      // Insert DistributorCode after "type"
      entries.splice(typeIndex + 1, 0, distributorField);

      // Convert back to object
      return Object.fromEntries(entries);
    }

    return config;
  })();

  const handleDeleteConfirm = async (selectedRow: any) => {
    try {
      const res = await AuthService.DeleteOrder(selectedRow);
      if (res?.status === 200 && res?.data === true) {
        toast.success(res?.message || "Deleted successfully");
        setDeleteModalOpen(false);
        FetchAllOrders();
      } else {
        toast.error(res?.error || "Something went wrong");
      }
    } catch (error: any) {

      const backendMessage =
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";

      toast.error(backendMessage);
    }
  };

  const onSubmitEdit = async (values: any) => {
    const payload = {
      companyName: values.companyName,
      name: values.name,
      designation: values.designation,
      mobileNumber: values.mobileNumber,
      emailId: values.emailId,
      address: values.address,
      // address: ,
      latitude: values.latitude,
      longitude: values.longitude,
      cityId: values.cityId,
      stateId: values.stateId,
      countryId: values.countryId,
      distributorId: 1,
      pincode: values.pincode,
      // gstNo: ,
      // panNo: ,
      // contactName: ,
      contactNo: values.contactNo,
      contactEmail: values.contactEmail,
      rejectedReason: "",
    };
    try {
      const res = await AuthService.EditRetailer(selectedRow.id, payload);

      if (res?.status === 200 && res?.message) {
        toast.success(res.message || "Warehouse updated successfully");
        FetchAllOrders();
        setEditModalOpen(false);
      } else {
        toast.error(res?.error || "Failed to update warehouse");
      }
    } catch (error) {
    }
  };

  const handleCopy = () => {
    if (!shareLink) return;

    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    toast.success("Link Copied!");

    setTimeout(() => {
      setCopied(false); // reset after 2 sec
    }, 2000);
  };

  const currentConfig = TAB_CONFIG[activeTab];
  return (
    <>
    {/* <ApprovedSalesDeliveryModal
        isOpen={deliverModalOpen}
        onClose={handleCloseDeliverModal}
        orderData={selectedOrderForDelivery}
        onSuccess={handleDeliverySuccess}
      /> */}

    <div className="p-5">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Sales Orders</h2>
        <div className="flex items-center gap-3">
          {/* 📎 GENERATED URL INPUT */}
          {shareLink && (
            <div className="flex items-center px-2">
              <input
                value={shareLink}
                readOnly
                className="outline-none w-72 text-sm"
              />
              <button
                onClick={handleCopy}
                disabled={copied}
                className={`font-medium ml-2 transition-all duration-200 ${copied ? "text-blue-600" : "text-blue-600"
                  }`}
              >
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
          )}
          <CustomHeader
            search={search}
            setSearch={setSearch}
            onButtonClick={() => handleOpenModal()}
            buttonLabel="Add Order"
          />
        </div>
      </div>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          textColor="primary"
          indicatorColor="primary"
        >
          {ORDER_TABS.map((tab) => (
            <Tab key={tab.key} label={tab.label} value={tab.key} />
          ))}
        </Tabs>
      </Box>

      {totalRecords === 0 ? (
        <div className="flex flex-col items-center justify-center mt-20">
          <img
            src="/assets/media/shopping_9725756.png"
            alt="No Retailer added yet"
            className="w-40 h-40 mb-4"
          />
          <h3 className="text-lg font-semibold mb-2">No Order added yet</h3>
          <p className="text-gray-500 mb-4">
            Add a Order and kickstart operations
          </p>
          <button
            onClick={handleOpenModal}
            className="px-4 py-2 bg-blue-600 text-white rounded-md cursor-pointer"
          >
            Add Order
          </button>
        </div>
      ) : (
        <>
          <Table columns={currentConfig.columns} data={attendanceData} />

          <Pagination
            isPagination={true}
            totalCount={totalRecords ?? 0}
            pageSelected={pageSelected}
            setPageSelected={setPageSelected}
            rowsPerPageValue={rowsPerPageValue}
            setRowsPerPageValue={setRowsPerPageValue}
            customRowsPerPage={false}
          />
        </>
      )}

      <Modal
        modalOpen={modalOpen}
        closeModal={handleCloseModal}
        heading="Add Order"
        saveButtonText="Submit"
        onSave={handleSubmit(onSubmit)}
        width="600px"
        isSubmitting={formState.isSubmitting}
      >
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-10">
          <div className="grid grid-cols-2 gap-4">
            {formRenderer(dynamicFormConfig, formState, register, control)}
          </div>

          <div className="mt-4">
            <h4 className="text-xl font-semibold mb-4">Add Products</h4>
            {fields.map((field, index) => {
              const row = watchedProducts[index];
              const isRowFilled = row?.productCode && row?.quantity;
              const isLastRow = index === fields.length - 1;
              const canDelete = fields.length > 1;
              const showAddButton = isLastRow && isRowFilled;

              return (
                <div key={field.id} >
                  <div className="grid grid-cols-2 gap-4">
                    {formRenderer(
                      getProductRowConfig(index),
                      formState,
                      register,
                      control
                    )}
                  </div>

                  <div className={styles.rowActions}>
                    {showAddButton && (
                      <span
                        className={styles.addMore}
                        onClick={() =>
                          append({
                            productCode: "",
                            quantity: "",
                          })
                        }
                      >
                        + Add more
                      </span>
                    )}

                    {canDelete && (
                      <span
                         className={styles.deleteRow}
                        onClick={() => remove(index)}
                      >
                        Delete
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </form>
      </Modal>

      <Modal
        modalOpen={mapModalOpen}
        closeModal={() => setMapModalOpen(false)}
        heading="Select Address on Map"
        width="800px"
        onSave={() => handleSave(selectedAddress)}
      >
        <MapView
          defaultLat={mapLocation.lat}
          defaultLng={mapLocation.lng}
          onSelectLocation={handleSelectLocation}
          showSearchBar={true}
        />
      </Modal>

      <Modal
        modalOpen={deleteModalOpen}
        closeModal={() => setDeleteModalOpen(false)}
        heading="Delete Retailer"
        width="400px"
        hideHeader={true}
        hideFooter={true}
      >
        <div className="flex flex-col items-center text-center p-4">
          <img src="/assets/media/Delete.png" className="w-14 mb-3" />

          <h2 className="text-lg font-semibold mb-2">Delete Order</h2>
          <p className="text-gray-500 mb-6">
            Are you sure you want to delete this Order?
          </p>

          <div className="flex gap-4 justify-center">
            <button
              className="px-6 py-2 border rounded-md"
              onClick={() => setDeleteModalOpen(false)}
            >
              Cancel
            </button>

            <button
              className="px-6 py-2 text-white rounded-md"
              style={{ backgroundColor: "#6570FC" }}
              onClick={() => handleDeleteConfirm(selectedRow?.id)}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        modalOpen={editModalOpen}
        closeModal={() => setEditModalOpen(false)}
        heading="Edit Retailer"
        width="800px"
        saveButtonText="Update"
        onSave={handleSubmit(onSubmitEdit)}
      >
        <form className="space-y-10" onSubmit={handleSubmit(onSubmitEdit)}>
          <div className="grid grid-cols-2 gap-1.5">
            {formRenderer(dynamicFormConfig, formState, register, control)}
          </div>
        </form>
      </Modal>

      {/* accept reject */}
      <Modal
        modalOpen={RejectModal}
        closeModal={() => setRejectModal(false)}
        heading={"Reason for Rejection"}
        saveButtonText={"Reject"}
        onSave={handleSubmit(() =>
          StatusCheck("REJECT", selectedRow, rejectReason)
        )}
        width="500px"
      >
        <>
          <Typography mb={1}>
            Please provide reason for rejecting{" "}
            <strong>
              {selectedRow?.Name} <span style={{ color: "red" }}>*</span>
            </strong>
            :
          </Typography>

          <textarea
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="Enter reason..."
            required
            style={{
              width: "100%",
              minHeight: "80px",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
        </>
      </Modal>
    </div>
    </>
  );
};

export default Order;
